var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "@mui/material/styles/styled";
import { IdCardNote } from "../ID-Note";
const IDCardFooterWrapper = styled("section")(({ theme }) => {
    return {
        display: "flex",
        ".id-footer_left": {
            display: "flex",
            alignItems: "center",
            gap: 10,
            ".id-footer_registeredText": {
                fontSize: 9.5,
            },
        },
        ".id-footer_right": {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginRight: 0,
            float: "right",
            flex: 1,
            gap: 7,
            ".id-footer_note": {
                flexBasis: "20%",
                borderLeft: "1px solid rgb(71, 130, 196)",
                paddingLeft: 10,
                p: {
                    marginTop: 0,
                    marginBottom: 0,
                    fontWeight: 550,
                },
            },
        },
        ".id-footer_brandImg": {
            img: {
                width: 200,
                height: 47,
            },
            p: {
                margin: 0,
            },
        },
        // Responsive
        [theme.breakpoints.down(768)]: {
            ".id-footer_left": {
                gap: 0,
            },
            ".id-footer_registeredText": {
                fontSize: "6px !important",
            },
            ".id-footer_link": {
                fontSize: 7,
                marginLeft: 10,
                marginRight: 5,
            },
            ".id-footer_brandImg": {
                img: {
                    width: 70,
                    height: 18,
                },
                p: {
                    fontSize: "0.28em",
                },
            },
            ".id-footer_note": {
                p: {
                    fontSize: "1.2vm",
                },
            },
        },
    };
});
export const IDCardFooter = React.memo((props) => {
    const { Link, img, note } = props;
    const _a = img || {}, { subTitle } = _a, imgProps = __rest(_a, ["subTitle"]);
    return (React.createElement(IDCardFooterWrapper, { className: "id-card_footer", style: props.style },
        React.createElement("div", { className: "id-footer_left" },
            React.createElement("p", { className: "id-footer_registeredText" }, props.registeredText),
            Link ? (React.createElement("div", { className: "id-footer_link" },
                React.createElement(Link, null))) : null),
        React.createElement("div", { className: "id-footer_right" },
            React.createElement("div", { className: "id-footer_brandImg" },
                React.createElement("img", Object.assign({}, imgProps, { alt: imgProps.alt })),
                React.createElement("p", null, subTitle)),
            React.createElement("div", { className: "id-footer_note" },
                React.createElement(IdCardNote, { text: note })))));
});
